import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../authContext";
import SweetAlert from "../../Components/SweetAlert";
import serverPath from "../../utils/serverPath";
import useStore from "../../store/store";
const ActiveInactiveUsers = (props) =>
{
  const context = useContext(AuthContext);
  const [globalState, dispatch] = useStore();
  const {activeInactiveUsers} = globalState;
  const [activeInactiveUsersTable, setActiveInactiveUsersTable] = useState(null);
  const [oldSearch, setOldSearch] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const initialFields = {
    activeInactiveUsers: [],
    status: "active",
    count: 0,
    pageNumber: 1,
  };
  const [fields, setFields] = useState({...initialFields});
  
  const submitHandler = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(serverPath("/get/activeInactiveUsers"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("A_TOKEN")}`,
        },
        body: JSON.stringify({
          status: fields.status,
          pageNumber: Number(fields.pageNumber) || 1,
        }),
      });

      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `Request failed (${res.status})`);
      }

      // NOTE: adjust these names to match your backend response
      const payload = await res.json();
      const serverStatus = payload.status;           // "success" | "failure"
      const rows = payload.data || [];               // array of users
      const total = payload.count ?? payload.total;  // whichever your API returns

      if (serverStatus === "success") {
        if ((total ?? rows.length) >= 1) {
          activeInactiveUsersTable?.destroy?.();
          changeHandler(total ?? rows.length, "count");
          changeHandler(rows, "activeInactiveUsers");
          dispatch("setData", { type: "activeInactiveUsers", data: rows });
        } else {
          SweetAlert("info", "Nothing found for Active/Inactive users.");
          // optional: clear table
          changeHandler(0, "count");
          changeHandler([], "activeInactiveUsers");
        }
      } else {
        SweetAlert("warning", payload.message || "Server returned failure.");
      }
    } catch (err) {
      SweetAlert("warning", err.message || "Network error");
    } finally {
      setIsLoading(false);
    }
  };

  const changeHandler = (value, type) =>
  {
    setFields(prev => ({...prev, [type]: value}));
  }

  return (
    <div className="main-content">
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-0">Find By Filter</h4>
                </div>

                <div className="card-body">
                  <form
                    onSubmit={(e) => { e.preventDefault(); if (!isLoading) submitHandler(); }}
                  >
                    <div className="form-row align-items-end">
                      <div className="form-group col-lg-4 col-md-6">
                        <label htmlFor="statusSelect">User Status</label>
                        <select
                          id="statusSelect"
                          className="form-control"
                          value={fields.status}
                          onChange={({ target }) => changeHandler(target.value, "status")}
                        >
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>

                      {fields.count >= 1 && (
                        <div className="form-group col-lg-4 col-md-6">
                          <label htmlFor="pageInput">
                            Page <small className="text-muted ml-1">
                              (max {Math.ceil(fields.count / 500) || 1})
                            </small>
                          </label>
                          <div className="input-group">
                            <input
                              id="pageInput"
                              type="number"
                              className="form-control"
                              value={fields.pageNumber}
                              min={1}
                              max={Math.ceil(fields.count / 500) || 1}
                              step={1}
                              onChange={({ target }) =>
                                changeHandler(target.value.replace(/\D+/g, ""), "pageNumber")
                              }
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">
                                / {Math.ceil(fields.count / 500) || 1}
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="form-group col-lg-4 col-md-6">
                        <button
                          type="submit"
                          className={`btn btn-primary btn-block ${isLoading ? "btn-progress" : ""}`}
                          disabled={isLoading}
                          aria-busy={isLoading}
                        >
                          {isLoading && (
                            <span
                              className="spinner-border spinner-border-sm mr-2"
                              role="status"
                              aria-hidden="true"
                            />
                          )}
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="section-body">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4>Users Status From Mobile App</h4>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-hover" id="tableExport">
                      <thead>
                        <tr>
                          <th className="text-center">
                            #
                          </th>
                          <th>Image</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {fields.activeInactiveUsers.map((user, index) => {
                          return (
                            <tr key={user.id}>
                              <td>
                                {(index + 1)}
                              </td>
                              <td>
                                <img 
                                  src={user.image} 
                                  alt="Profile" 
                                  className="rounded-circle" 
                                  style={{ width: "40px", height: "40px", objectFit: "cover" }} 
                                />
                              </td>
                              <td>{user.name}</td>
                              <td>{user.email}</td>
                              <td>
                                {
                                  user.status === "active" ?
                                  <div className="badge badge-success badge-shadow">Active</div>
                                  :
                                  <div className="badge badge-warning badge-shadow">In Active</div>
                                }
                              </td>
                            </tr>
                          )})}
                      </tbody>
                    </table>
                    <div>
                      <p>Total Users: {fields.count}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}


export default ActiveInactiveUsers;